import Navigo from 'navigo';
import $ from 'jquery';
import ko from 'lib/knockout';
import * as locationUtils from '../location';
import * as loggerUtils from '../logger';
import {UrlParser} from "../../../core/utils/url";
import {UrlBuilder} from "../url";

const logger = loggerUtils.newLogger('Router');

export class Router {
	static defaults = {
		baseUrl: '',
	};

	delay = 0;

	_navigo = null;
	_baseUrl = null;
	/** @type {NavUrl} */
	_currentUrl = null;
	_navData = null;
	_onInitialize = $.Callbacks();
	_onNavigate = $.Callbacks();
	_initialized = false;
	_handlerData = null;
	_request = ko.observable();

	init(baseUrl) {
		this._baseUrl = baseUrl || '';
		this._navigo = new Navigo(this._baseUrl);
		this._routeHandler = this._routeHandler.bind(this);
		this._navigo.on({
			'/': query => this._routeHandler({}, query),
			'/:category': this._routeHandler,
			'/:category/:subcategory': this._routeHandler
		});
		this._navigo.notFound(function () {
			logger.warn('Unknown route', location.pathname);
		});
		this._navigo.resolve();
		this._request.subscribe((req) => {
			this._navigateImmediate(req.url, req.data);
		});
		this._initialized = true;
	}

	onInitialize(callback) {
		this._onInitialize.add(callback);
	}

	onNavigate(callback) {
		this._onNavigate.add(callback);
	}

	get enabled() {
		return window.history && window.history.pushState;
	}

	get initialized() {
		return this._initialized;
	}

	get navData() {
		return this._navData;
	}

	get baseUrl() {
		return this._baseUrl;
	}

	/**
	 * @param {NavUrl|string} url
	 * @param {object} data
	 */
	navigate(url, data = null) {
		if (url instanceof NavUrl) {
			url = new NavUrl(
				this._prepUrl(url.path),
				url.queryData
			);
		} else {
			const parser = new UrlParser(url);
			url = new NavUrl(this._prepUrl(parser.pathname), parser.search);
		}
		this._request({url, data});
	}

	/**
	 * @param {NavUrl} url
	 * @param {object} handlerData
	 */
	_navigateImmediate(url, handlerData = null) {
		if (this._initialized && !url.equals(this._currentUrl)) {
			logger.info('navigate to:', url);
			this._currentUrl = url;
			this._handlerData = handlerData;
			const urlString = url.build();
			const absolute = /^https?:\/\//i.test(urlString);
			if (this.enabled) {
				this._navigo.navigate(urlString, absolute);
			} else {
				location.href = absolute ? urlString : this._baseUrl + urlString;
			}
		}
	}

	_prepUrl(url) {
		const parser = new UrlParser(this._baseUrl);
		return url.replace(parser.origin, '')
			.replace(parser.pathname, '')
			.replace(/^\/|\/$/g, '');
	}

	_routeHandler(params, query) {
		if (location.href.indexOf(this._baseUrl) !== 0) {
			location.reload();
			return;
		}
		const path = this._prepUrl(location.pathname);
		const queryData = locationUtils.decodeQueryString(query);
		this._currentUrl = new NavUrl(path, queryData);
		this._navData = {
			url: location.href,
			baseUrl: this._baseUrl,
			params,
			query,
			queryData,
			data: this._handlerData
		};
		this._handlerData = null;
		logger.log('new navData:', this._navData);
		if (this._initialized) {
			this._onNavigate.fire(this._navData);
		} else {
			this._onInitialize.fire(this._navData);
		}
	};
}

export class NavUrl {
	constructor(path, queryData) {
		this._path = path;
		this._queryData = queryData;
		this._url = new UrlBuilder(null, null, null, this._path, this._queryData, null).build();
	}

	get path() {
		return this._path;
	}

	get queryData() {
		return this._queryData;
	}

	build() {
		return this._url;
	}

	/**
	 * @param {NavUrl} url
	 * @return {boolean}
	 */
	equals(url) {
		return url instanceof NavUrl &&
			this._path == url._path &&
			_.isEqual(this._queryData, url._queryData);
	}

	toString() {
		return this._url;
	}
}



// WEBPACK FOOTER //
// ./core/utils/nav/router.js